import { render } from "./SplashScreen.vue?vue&type=template&id=b8a00db0"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"

import "./SplashScreen.vue?vue&type=style&index=0&id=b8a00db0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__